export class ErrorMessages {
    static NO_FUNCTIONALITIES = 'No functionalities found';
}
